import { css } from 'lit';

export const dialogOverlayStyles = css`
  :host {
    position: fixed;
    inset: 0;
    display: grid;
    place-items: center;
    padding: var(--gap-4);
    box-sizing: border-box;
    z-index: 6;
    --kv-dialog-bg: var(--color-sidebar-bg);
  }

  sp-underlay {
    z-index: 1;
    background-color: var(--color-modal-overlay);
  }

  .dialog-container {
    position: relative;
    z-index: 2;
    justify-items: center;    
  }

  sp-dialog {
    background: var(--kv-dialog-bg);
  }
`;
